<template>
    <div>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="doSetLayoutAreaDevc()" v-if="layoutAreaLevel ==2">
                    <span>设置首要设备</span>
                </button>
                <button class="swb-btn swb-btn-small" @click="doCancelLayoutAreaDevc()">
                    <span>取消全部设备</span>
                </button>
                <button class="swb-btn swb-btn-small" @click="doSetLayoutAreaDevcRel()" v-if="layoutAreaLevel ==2">
                    <span>关联设备</span>
                </button>
            </div>
            <div class="right"></div>
        </div>
        <swb-shop-device-list-for-select :filter="filter" :checkedItem="checkedItem" :checkBox="false" ref="device_select_list"></swb-shop-device-list-for-select>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher, filterByName } from '../../app.vues'
    import { showDevcSelectDlg } from '../devc/selectDlg'

    import merchtComnApi from '../../api/merchtComn'
    import devcApi from '../../api/devc'

    import SwbShopDeviceListForSelect from '../devc/ShopDeviceListForSelect';
    Vue.regist(SwbShopDeviceListForSelect);

    export default {
        name: 'swb-retailer-layout-area-devc-list',
        desc: '布放区设备列表',
        props: {
            layoutAreaId: {
                type: Number,
                default: null
            },
            layoutAreaLevel: {
                type: Number,
                default: null
            },
            temperAffectedDevcId: {
                type: Number,
                default: null
            },
            bizUnitId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                filter: {},
                checkedItem: {},
                singlecheck: {
                    isShowSelection: false
                },
                checkedDevc: {}, // 选中的首要设备
                needRefresh: false,
                totalCount: 0
            }
        },
        created(){
            if(!Utils.isNoB(this.layoutAreaId)) {
                let filter = this.filter || {};
                if(!Utils.isNoB(this.layoutAreaLevel)) {
                    if(this.layoutAreaLevel == 1) {
                        filter.layoutAreaId1 = this.layoutAreaId;
                    } else {
                        filter.layoutAreaId = this.layoutAreaId;
                    }
                }
                filter.retailerComId = this.bizUnitId;
                this.filter = Utils.merge({}, filter);
            }
            if(!Utils.isNoB(this.temperAffectedDevcId)) {
                let checkedItem = this.checkedItem || {};
                checkedItem.id = this.temperAffectedDevcId;
                this.checkedItem = Utils.merge({}, checkedItem);
            }
        },
        mounted() {
        },
        methods: {
            handleChange: function (item) {
                let checkedItem = item.checkedItem;
                this.checkedDevc = Utils.merge({}, checkedItem);
            },
            // 设置首要设备
            doSetLayoutAreaDevc: function () {
                let self = this;
                let totalCount = this.$refs.device_select_list.getTotalCount();
                if(totalCount > 0) {
                    let checkedItem = this.$refs.device_select_list.getTableSelection() || null;
                    if(Utils.isNoB(checkedItem) || Utils.isNoB(checkedItem.id)) {
                        MsgBox.warning("请选择具体的设备！");
                        return;
                    }
                    //
                    let postData = {
                        id: self.layoutAreaId,
                        temperAffectedDevcId: checkedItem.id
                    };
                    let theLoad = MsgBox.loading();
                    merchtComnApi.updateRetailerLayoutAreaDevcInfo(postData, function (result) {
                        theLoad.hide();
                        if(result.type == 'info') {
                            //
                            MsgBox.success("设置成功！");
                            self.needRefresh = true;
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    MsgBox.warning("请关联设备后再设置首要设备！");
                }
            },
            // 取消全部关联设备
            doCancelLayoutAreaDevc: function () {
                let self = this;
                //
                let totalCount = this.$refs.device_select_list.getTotalCount();
                if(totalCount > 0) {
                    self.$confirm('确定要取消全部设备吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        //
                        let postData = {
                            layoutAreaId: self.layoutAreaId
                        };
                        let theLoad = MsgBox.loading();
                        devcApi.updateShopDeviceLayoutAreaIdNoneByLayoutAreaId(postData, function (result) {
                            theLoad.hide();
                            if(result.type == 'info') {
                                //
                                MsgBox.success("操作成功！");
                                self.needRefresh = true;
                                self.$refs.device_select_list.getDataList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }).catch(function () {
                    });
                }
            },
            // 关联设置
            doSetLayoutAreaDevcRel: function () {
                // 通用选择-资产信息
                let self = this;
                let filter = {
                    retailerComId: self.bizUnitId,
                    cleared: false,
                    layoutAreaNone: true,
                    assetType: 0
                };
                let params = {
                    filter: filter
                };
                showDevcSelectDlg(params, function (deviceList) {
                    if(deviceList.length <= 0) {
                        MsgBox.warning("请选择设备");
                        return false;
                    }
                    if(deviceList.length > 100) {
                        MsgBox.warning("每次最多选择100个设备！");
                        return false;
                    }
                    let ids = deviceList.pluck("id");
                    self.updateLayoutAreaIdByIds(ids, self.layoutAreaId);
                });
            },
            // 修改设备布放区信息
            updateLayoutAreaIdByIds: function (ids, layoutAreaId) {
                let self = this;
                let postData = {
                    ids: ids,
                    layoutAreaId: layoutAreaId
                };
                let theLoad = MsgBox.loading();
                devcApi.updateShopDeviceLayoutAreaIdByIds(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        if(Utils.isTrue(result.data)) {
                            MsgBox.success("设置成功");
                            self.needRefresh = true;
                            self.$refs.device_select_list.getDataList();
                        } else {
                            MsgBox.warning("设置失败");
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                return this.needRefresh;
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/layoutArea/RetailerLayoutAreaDevcList.vue